import React from "react";
import { useTranslation } from "react-i18next";

import { QuestionForm, QuestionList } from "./";
import { ManagementLayout } from "@components/shared";
import { Card, Title } from "@mantine/core";

import { question } from "@dummy/question";

export default function QuestionManagement() {
  const { t } = useTranslation();
  return (
    <ManagementLayout
      dataComponent={<QuestionList items={[question]} />}
      createComponent={
        <Card>
          <Title order={4}>
            {t("create")} {t("cs:question_singular")}
          </Title>
          <QuestionForm onSuccess={() => {}} />
        </Card>
      }
    />
  );
}
